<div
  class="notification-item p-4 border-b border-gray-200 cursor-pointer hover:bg-gray-100 transition-colors"
  [class.bg-gray-50]="!notification.isRead"
  tabindex="0"
  (click)="onItemClick()"
  (keydown.enter)="onItemClick()"
>
  <div class="flex gap-2">
    <!-- Colonna laterale per il pallino della notifica -->
    <div class="flex-col w-2 mt-1.5">
      @if (!notification.isRead) {
      <span class="block w-2 h-2 bg-red-500 rounded-full"></span>
      }
    </div>

    <div class="flex-col">
      <div class="flex flex-col justify-between items-start">
        <h4 class="font-semibold text-gray-900 text-sm">{{ notification.title }}</h4>
      </div>

      <p class="text-gray-600 text-sm mt-1 line-clamp-2">{{ notification.body }}</p>

      <span class="text-gray-400 text-xs mt-2 block">
        {{ notification.createdAt | relativeTime }}
      </span>
    </div>
  </div>
</div>